// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 95) return "static/chunks/95-f13f06d82e20afce.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"17":"89b2f1ba8d6a2258","24":"9bfb8a4c6bbc66a5","34":"2691f01a857e3b70","156":"7ee579cd3b7c04ae","692":"d25c43405d442c72","728":"99ff4620895592ad"}[chunkId] + ".js";
};